import Helpers from '../base/Helpers';
import PaymentTransaction from './PaymentTransaction';

export default class SaleTransaction extends PaymentTransaction {
	/**
	 * Transaction installment type
	 */
	installment_type?: string = undefined;

	/**
	 * Transaction installment value
	 */
	installment_months?: string = undefined;

	/**
	 * Transaction total points redeem amount
	 */
	points_redeem_amount?: string | null = undefined;

	/**
	 * Set Installment service values to transaction
	 *
	 * @param months
	 * @param type
	 */
	setInstallment(months: number, type: string) {
		this.installment_months = String(months);
		this.installment_type = type;
	}

	/**
	 * Set transaction points redeem amount
	 *
	 * @param amount
	 */
	withPointsRedeemAmount(amount: number) {
		this.points_redeem_amount = Helpers.parseAmount(amount);
	}
}
